export const completedTaskStatuses = ["completed", "locked", "archived"];
export const scheduledTaskStatuses = ["scheduled", "postponed"];

export interface TaskProgress {
  total: number;
  completed: number;
  late: number;
  scheduled: number;
}

interface PlaceItem {
  campaigns: Campaign[];
  requests: Request[];
}

interface Campaign {
  id: number;
  status: string;
  due_date: string;
  scheduled_date: string;
}

interface Request {
  status: string;
  due_date: string;
  scheduled_date: string;
}

export function applyTaskFilter<Markers extends PlaceItem>(
  items: Markers[],
  campaignFilterIds: number[],
  campaignStatus: string[],
): (Markers & { selected_campaigns: Campaign[]; progress: TaskProgress })[] {
  return items.map((item) => ({
    ...item,
    selected_campaigns: selectedCampaigns(item, campaignFilterIds, campaignStatus),
    progress: taskProgress(item, campaignFilterIds, campaignStatus),
  }));
}

export function taskProgress(
  item: PlaceItem,
  campaignFilterIds: number[],
  campaignStatus: string[],
): TaskProgress {
  const campaigns = selectedCampaigns(item, campaignFilterIds, campaignStatus);
  const requests = selectedRequests(item, campaignFilterIds);
  const tasks = [...campaigns, ...requests];

  return tasks.reduce(
    (progress, task) => {
      progress.total++;

      if (completedTaskStatuses.includes(task.status)) {
        progress.completed++;
      } else if (isLateTask(task)) {
        progress.late++;
      } else if (scheduledTaskStatuses.includes(task.status)) {
        progress.scheduled++;
      }

      return progress;
    },
    {
      completed: 0,
      scheduled: 0,
      late: 0,
      total: 0,
    },
  );
}

export function selectedCampaigns(
  item: PlaceItem,
  campaignFilterIds: number[],
  campaignStatus: string[],
): Campaign[] {
  return item.campaigns.filter(
    (campaign) =>
      (campaignFilterIds.length === 0 || campaignFilterIds.includes(campaign.id)) &&
      (campaignStatus.includes("all") || campaignStatus.includes(campaign.status)),
  );
}

export function selectedRequests(item: PlaceItem, campaignFilterIds: number[]): Request[] {
  if (campaignFilterIds.length === 0) {
    return item.requests;
  } else {
    return [];
  }
}

function isLateTask(task: Campaign | Request): boolean {
  const dueDate = task.scheduled_date || task.due_date;
  const today = new Date().toISOString().slice(0, 10);

  return today > dueDate;
}
